
<template>
  <v-container class="ma-0">
  <v-card class="d-flex-column mt-2"
    :loading="loading"
    >
    <v-card-title>
       <h1 class="mr-2 subheading grey--text">Επαφές</h1>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    <v-spacer/>
      <v-btn
      color="primary"
      dark
      small
      @click="addNewContact"
    >
    <v-icon>mdi-plus</v-icon> Νεα Επαφη
    </v-btn>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="contact">
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="8"
                md="6"
              >
                <v-text-field
                  label="Ονοματεπώνυμο"
                  :rules="[rules.required]"
                  v-model="editedItem.Name"
                  dense
                  ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm=8
                md=8
                xs=12
              >
                <v-text-field
                  label="Θέση"
                  :rules="[rules.required]"
                  v-model="editedItem.JobDesc"
                  required
                  dense
                  ></v-text-field>
              </v-col>
            <v-col cols="6" sm="6" md=4>
                <v-text-field
                  label="Τηλέφωνο*"
                  type="tel"
                  v-model.number="editedItem.Telephone"
                  dense
                  ></v-text-field>
            </v-col>
             <v-col cols="6" sm="6" md=4>
                <v-text-field
                  label="Κινητό*"
                  type="tel"
                  v-model.number="editedItem.Mobile"
                  dense
                  ></v-text-field>
            </v-col>
              <v-col cols=8 sm=8 md=6>
                <v-text-field
                  label="Διεύθυνση Ηλ. Ταχυδρομείου*"
                  type="tel"
                  :rules="[rules.email]"
                  v-model.number="editedItem.Email"
                  dense
                  ></v-text-field>
            </v-col>

            
            </v-row>
          </v-container>
          <small>*indicates required field</small>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialog = false"
          >
            Κλείσιμο
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="saveContact"
          >
            Αποθήκευση
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  

    </v-card-title>

  <v-item-group class="pt-4">
    <v-container fluid>
 <v-sheet class="d-flex flex-wrap bg-surface-variant justify-space-evenly ma-2">
        <v-col
          v-for="c in filteredContacts"
          :key="c.Id"
          class="ma-4 pt-2"
        >
          <v-item>
            <contact-details :contact="c" :avatar="avatar(c.Id)" />
          </v-item>
          </v-col>
      </v-sheet>
    </v-container>
  </v-item-group>

   
  </v-card>
      </v-container>
</template>


<script>
import ContactDetails from "../../components/ContactDetails.vue";

export default {
  components: {
    ContactDetails
  },
  computed: {
    filteredContacts () {
        return this.contacts.filter(el => el.Name.includes(this.search.toUpperCase()));
    },
  },
  data() {
    return {
      expanded: [],
      dialog: false,
      loading: true,
      search: "",
      contacts: [],
      formTitle: "Νέα επαφή",
      editedItem: { },
      newItem: {
       Name: '',
       JobDesc: null,
       Telephone: null,
       Mobile: null,
       Email: null,     
      },
      customer_id: this.$route.params.id,
      rules: {
          required: value => !!value || 'Required.',
           email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            if (value) {
                return pattern.test(value) || 'Invalid e-mail.'
            }
            return
          },
        },
    }
  },
  async mounted() {
      try {
        this.loading = true;
        const response = await this.$api.get('/customers/contacts/'+this.$route.params.id);
        this.contacts = response.data;
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
watch: {
      timdialog (val) {
        val || this.close()
      },
},
  methods: {
    avatar (id) {
        if (id % 2) return "../assets/nina-mercado-e9YFrEBWit8-unsplash.jpg"
        return "../assets/kenny-eliason-60krlMMeWxU-unsplash.jpg"
    },
    addNewContact() {
        this.editedItem = Object.assign({}, this.newItem);
        this.dialog = true;
        
    },
    
     async saveContact () {
      console.log(this.newContact);
      if (this.$refs.contact.validate()) {
        if (this.editedItem.Telephone) this.editedItem.Telephone = this.editedItem.Telephone.toString()
        if (this.editedItem.Mobile) this.editedItem.Mobile = this.editedItem.Mobile.toString()
        const resp = await this.$api.post(`/customers/contacts/${this.customer_id}`, this.editedItem);
        if (resp.status == 201) {
          try {
                this.loading = true;
                const response = await this.$api.get('/customers/contacts/'+this.$route.params.id);
                this.contacts = response.data;
                this.loading = false;
              } catch (error) {
                console.error(error);
              }
        } else
        {
          alert(resp.data.detail);
        }

        this.dialog = false;
      }
    },
    
  }
}
</script>
